import { _, $, Backbone } from "../../../vendor";
import { Backform, Notification, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import ResourcesFormTpl from "../../templates/contingents/ResourcesFormTpl.html";

export default InboomaBaseView.extend({
  el: "#inb-resource-edit-modal",
  template: ResourcesFormTpl,

  ui: {
    errorMessageField: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    // we need another name for this field because of autocomplete
    this.model.set("nameA", this.model.get("name"));

    const that = this,
      fields = [
        {
          name: "nameA",
          label: this.t("name", null, "capital"),
          control: "input",
          required: true,
          size: {
            large: "12",
          },
        },
        {
          name: "secret",
          label: this.t("resource_secret", null, "capital"),
          control: "input",
          size: {
            large: "12",
          },
        },
        {
          name: "mac",
          label: this.t("mac_adress"),
          required: true,
          control: "input",
          disabled: Biscuit.get("user.role") != "admin", // WAS: that.model.get('mac') !== ''
          size: {
            large: "12",
          },
        },
        {
          name: "external_resource_id",
          label: this.t("external_resource_id"),
          control: "input",
          size: {
            large: "12",
          },
        },
        {
          name: "note",
          label: this.t("note"),
          control: "textarea",
          size: {
            large: "12",
          },
        },
        {
          name: "location_id",
          label: this.t("resource_start_location", null, "capital"),
          control: "selector",
          required: true,
          forceFirstSelected: true,
          disabled:
            this.model.get("id") != "" &&
            this.model.get("location_id") != "" &&
            this.model.get("location_id") !== null,
          options: _.map(this.options.parent.get("locations"), (location) => {
            return { label: location.name, value: location.id };
          }),
        },
        {
          label: this.t("save"),
          control: "button",
          extraClasses: ["expanded button-submit"],
        },
      ],
      resourcesModal = new Foundation.Reveal(this.$el),
      form = new Backform.Form({
        el: that.$el.find("form"),
        model: that.model,
        fields: fields,

        events: {
          "click .button-submit"(ev) {
            ev.preventDefault();

            // @todo this.$el.foundation?! Or is foundation mapped to $?!
            $(that.$el.find("form")).foundation("validateForm");

            if (
              typeof that.model != "undefined" &&
              that.model.isValid() &&
              !that.$el.find("form .is-invalid-input").length
            ) {
              const isNew = that.model.get("id") == "";

              that.model = OffCanvasBehavior.prototype.normalizeModel(that.model);
              that.model.set("client_id", Number(Biscuit.get("user.client_id")));
              // we need another name for this field because of autocomplete in false
              that.model.set("name", that.model.get("nameA"));
              delete that.model.attributes.nameA;
              // delete battery_value as clashing with API
              delete that.model.attributes.battery_value;

              if (isNew) {
                const _location = _.findWhere(that.options.parent.get("locations"), {
                  id: that.model.get("location_id"),
                });

                if (typeof _location == "undefined") {
                  alert("No valid location selected, will abort");
                  return;
                }

                that.model.set({
                  latitude: _location.latitude,
                  longitude: _location.longitude,
                });
              }

              that.model.save(null, {
                patch: true,
                success(model, response, options) {
                  resourcesModal.close();

                  new Notification({
                    message: that.t(
                      isNew ? "added_${a}" : "updated_${a}",
                      { a: that.t("resource") },
                      "capital",
                    ),
                    duration: 5000,
                    closeable: true,
                    icon: "fi fi-check",
                  });

                  if (isNew) {
                    let newResources = that.options.parent.get("resources");
                    newResources.push(model);

                    that.options.parent.set("resources", newResources);
                  }

                  that.options.parent.trigger("changed");
                },
                error(model, xhr, options) {
                  //resourcesModal.close();

                  that
                    .getUI("errorMessageField")
                    .removeClass("hide")
                    .html(that.t("request_error"))
                    .fadeIn("fast");
                },
              });
            } else {
              if (typeof that.model != "undefined") {
                that
                  .getUI("errorMessageField")
                  .removeClass("hide")
                  .html(that.t("form_validation_error"))
                  .fadeIn("fast");
              }
            }
          },
        },
      }).render();

    new Foundation.Abide(this.$el.find("form"), { liveValidate: true });

    resourcesModal.open();

    this.$el.on("closed.zf.reveal", () => {
      that.$el.foundation("_destroy");

      that.unbind();
      that.undelegateEvents();
      that.unbindEvents();
      that.unbindUIElements();

      Backbone.history.navigate("contingents");
      that.$el.off("closed.zf.reveal");
    });
  },
});
